import React, { useEffect } from 'react';
import AdminAddBookTemplate from '../../04_templates/AdminAddBookTemplate/AdminAddBookTemplate';

function AdminAddBookPage() {
  useEffect(() => {
    document.title = 'Sweet Bibi - Boek Toevoegen';
  }, []);
  
  return (
    <main>
      <AdminAddBookTemplate />
    </main>
  );
}

export default AdminAddBookPage;
